import {
  RnMoon4am,
  RnMoon5am,
  RnMoon6am,
  RnMoon8pmAnd7am,
  RnMoon9pm,
  RnMoon10pm,
  RnMoon11pm,
  RnMoon12amTo3am,
  RnSun4pm,
  RnSun5pm,
  RnSun6pm,
  RnSun8amAnd7pm,
  RnSun9am,
  RnSun10am,
  RnSun11am,
  RnSun12pmTo3pm,
} from "@remi/icons/next";

export const HourIcon: Record<number, React.JSX.Element> = {
  0: <RnMoon12amTo3am key="0" />,
  1: <RnMoon12amTo3am key="1" />,
  2: <RnMoon12amTo3am key="2" />,
  3: <RnMoon12amTo3am key="3" />,
  4: <RnMoon4am key="4" />,
  5: <RnMoon5am key="5" />,
  6: <RnMoon6am key="6" />,
  7: <RnSun8amAnd7pm key="7" />,
  8: <RnSun8amAnd7pm key="8" />,
  9: <RnSun9am key="9" />,
  10: <RnSun10am key="10" />,
  11: <RnSun11am key="11" />,
  12: <RnSun12pmTo3pm key="12" />,
  13: <RnSun12pmTo3pm key="13" />,
  14: <RnSun12pmTo3pm key="14" />,
  15: <RnSun12pmTo3pm key="15" />,
  16: <RnSun4pm key="16" />,
  17: <RnSun5pm key="17" />,
  18: <RnSun6pm key="18" />,
  19: <RnMoon8pmAnd7am key="19" />,
  20: <RnMoon8pmAnd7am key="20" />,
  21: <RnMoon9pm key="21" />,
  22: <RnMoon10pm key="22" />,
  23: <RnMoon11pm key="23" />,
};
